
<script>

import _ from 'lodash';
import Vue from 'vue';
import VueField from './vue-field.vue'
export default {

    props:{
        name:{
            required:true
        },
        value:{ //vmodel object
            type:Object,
            default:()=>{}
        },
        fields:{ //LETODO = create fields from prop fields
            type:Array
        },
        canvalidate:{
            default:true
        }
    },

    data(){
        return {
            values:{},
            errorFields:[],
        }
    },


    render:function(h){
            let children = this.$slots.default;
                // 
            
            if( ! _.isEmpty(this.$props.fields) ){
                let fileds = this.createFieldsFromProp( this.$props.fields )
                children = _.map(fileds, f =>  h('vue-field', {...f}) )
            }
          
            return h('form',
                    { on: {
                            submit:(event)=>{
                                event.preventDefault();
                                this.$emit('submit',event);
                            }
                        }
                    },
                    [ h('div',{ staticClass:'v-form'}, children ) ]
            ) 
    },

    watch:{
        valuesFromStore:function(newVal,oldVal){
            // console.log( 'valuesFromStore %o', newVal)
            //THE LOGIC IS EMITTING AN OBSERVER OBJECT TRANFORMS THE V-MODEL OBJECT IN PARENT
            this.values = {...newVal}
            this.$emit('change',this.values )
            this.$emit('input',this.values )   
        }
    },

    computed:{

        valuesFromStore:function(){
                return this.$store.getters.valueForForm(this.name)
        },

      

    },

    methods:{

        registeForm:function(){
            this.$store.form
        },

        createFieldsFromProp:function(fields){
          return _.map(fields, field=>{
                let {name, label, value, options, type, required, validation, disabled } = field
                return {
                    props:{ name, label, value, options, type, required, validation, disabled },
                }
          })
        },

        myVuefields:function(){
            let fieldsFound = [];
            function transverse(nodes){
                        if(_.isArray(nodes)){
                            for (let i = 0; i < nodes.length; i++) {
                                let vm = nodes[i];
                                transverse(vm)
                            }
                        }else if(_.isObject(nodes)) {
                            if( _.get(nodes,'$options.name',_.get(nodes,'$options._componentTag'))==='vue-field'){
                                    fieldsFound.push(nodes)
                            } else if(nodes.children){
                                    transverse(nodes.children)
                            }
                        }
            }
            
            transverse(this.$children)
            return fieldsFound
        },

        hasError:async function(){
            if(this.canvalidate == false){
                return false;
            }
            let error = false;
            let fields = this.myVuefields();
            //mak each of my vue-fields to validate
            for(let i = 0; i< fields.length; i++){
                  let vuefield = fields[i]
                  var res = await vuefield.runValidations();
                  if(res === false){
                      error = true
                  }
            }            
            console.log("form hasError: %o", error)
            return error;
        },

        getValues:function(){
            return this.values
        }

    }


}
</script>

<style>

</style>
